import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {SelectBonusBasicState, SelectBonusPlayingState, SelectBonusView} from '@gongxigames/framework/slot/modules/selectBonus';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {Module} from '@gongxigames/framework/slot';

export class SelectBonusModule extends Module<SelectBonusView, GlobalEventsMapForBackwardCompatibility> {
    public static readonly NAME: symbol = Symbol('SelectBonusModule');

    public static readonly BASIC_STATE: string = 'basic';
    public static readonly PLAYING_STATE: string = 'playing';

    protected _isRestore = false;

    protected setupStates(): void {
        this.addState(new SelectBonusBasicState(this, SelectBonusModule.BASIC_STATE));
        this.addState(new SelectBonusPlayingState(this, SelectBonusModule.PLAYING_STATE));

        this.gotoState(SelectBonusModule.BASIC_STATE);
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.onCurrentStateHandle(FlowModuleEvents.SELECT_BONUS_START);
        this.onCurrentStateHandle(LogicEvents.SELECT_RESPONSE);
    }

    protected setupViews(): void {
        this.setView(SelectBonusView.NAME);
    }

    public get isRestore(): boolean {
        return this._isRestore;
    }

    public set isRestore(value: boolean) {
        this._isRestore = value;
    }
}
